import { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { ConsentPreferencesDialog } from '@/modules/consent/components/consent-preferences-dialog';

/** Mounted once at the app root (see App.tsx) so it's reachable from every page, public or authenticated. */
export function ConsentPreferencesLauncher() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                aria-label="Cookie preferences"
                onClick={() => setOpen(true)}
                className="fixed bottom-4 left-4 z-50 flex size-11 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-transform hover:scale-105"
            >
                <ShieldCheck className="size-5" />
            </button>
            <ConsentPreferencesDialog open={open} onOpenChange={setOpen} />
        </>
    );
}
